var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatch01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1782.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:black;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 947.83,
    y: 57.42,
    width: 24.33,
    height: 96.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 947.83,
    y: 1637.11,
    width: 24.33,
    height: 88.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1702.11,
    y: 879.42,
    width: 92.03,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 125.86,
    y: 879.42,
    width: 83.17,
    height: 24.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1317.46 244.19 1338.53 256.34 1387.2 175.01 1366.13 162.86 1317.46 244.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "532.8 1608.07 553.81 1620.23 597.18 1545.46 576.09 1533.34 532.8 1608.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1614.56 1254.38 1602.41 1275.45 1676.55 1318.78 1688.71 1297.68 1614.56 1254.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.29 485.4 305.06 528.72 317.22 507.68 243.45 464.36 231.29 485.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1589.87 511.52 1602.02 532.6 1688.02 484.24 1675.84 463.2 1589.87 511.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 233.62,
    y: 1280.77,
    width: 65.65,
    height: 24.34,
    transform: "translate(-611.44 307.04) rotate(-30.04)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "244.13 1319.92 317.77 1276.5 305.58 1255.43 231.95 1298.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1355.48 1550.57 1334.38 1562.73 1367.27 1619.57 1388.36 1607.42 1355.48 1550.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1388.36 1607.42 1344.93 1532.6 1323.84 1544.76 1367.27 1619.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "531.63 175.69 575.05 250.85 596.12 238.67 552.65 163.51 531.63 175.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1034.18 125.89 1042.7 126.76 1049.52 60.6 1041 59.78 1034.18 125.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "870.11 1720.86 878.6 1721.74 885.39 1655.64 876.93 1654.73 870.11 1720.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1724.71 965.14 1723.8 973.64 1789.94 980.42 1790.82 971.96 1724.71 965.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "128.81 809.54 194.91 816.35 195.8 807.89 129.66 801.07 128.81 809.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1710.57 1054.76 1775.59 1068.61 1777.39 1060.3 1712.36 1046.47 1710.57 1054.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.3 721.17 207.3 735.02 209.03 726.67 144.03 712.85 142.3 721.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.94 1706.55 790.29 1708.28 804.12 1643.29 795.8 1641.52 781.94 1706.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1115.51 138.21 1123.88 140 1137.72 75 1129.39 73.18 1115.51 138.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1195.42 159.28 1203.54 161.92 1224.24 98.77 1216.12 96.1 1195.42 159.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "695.37 1682.72 703.48 1685.37 724.18 1622.25 716.09 1619.55 695.37 1682.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1688.65 1134.44 1751.8 1155.16 1754.47 1147.08 1691.29 1126.34 1688.65 1134.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "165.16 634.45 228.37 655.15 230.98 647.03 167.83 626.33 165.16 634.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1658.41 1210.93 1719.01 1238.31 1722.49 1230.53 1661.92 1203.18 1658.41 1210.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.13 550.97 257.7 578.34 261.25 570.56 200.62 543.22 197.13 550.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "612.28 1649.95 620.06 1653.42 647.38 1592.88 639.62 1589.37 612.28 1649.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1272.22 188.64 1280.04 192.13 1307.38 131.59 1299.6 128.07 1272.22 188.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1658.46 570.67 1661.99 578.45 1722.55 551.11 1719.09 543.33 1658.46 570.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.08 1230.38 200.57 1238.16 261.14 1210.79 257.61 1203.04 197.08 1230.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1279.86 1589.42 1272.12 1592.88 1299.48 1653.51 1307.21 1649.99 1279.86 1589.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "612.39 131.51 639.77 192.1 647.55 188.61 620.2 128.01 612.39 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1195.3 1622.27 1216 1685.45 1224.12 1682.79 1203.37 1619.63 1195.3 1622.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "695.56 98.74 716.26 161.92 724.38 159.25 703.63 96.07 695.56 98.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "165.16 1146.96 167.77 1155.03 230.95 1134.33 228.28 1126.26 165.16 1146.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1688.71 647.2 1691.37 655.32 1754.5 634.57 1751.83 626.47 1688.71 647.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1710.63 726.82 1712.39 735.17 1777.42 721.37 1775.59 713.02 1710.63 726.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.24 1060.16 143.98 1068.51 208.97 1054.64 207.27 1046.3 142.24 1060.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1115.39 1643.32 1129.19 1708.34 1137.55 1706.55 1123.69 1641.55 1115.39 1643.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.08 74.97 795.92 139.97 804.23 138.18 790.4 73.16 782.08 74.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1034.1 1655.64 1040.85 1721.77 1049.35 1720.89 1042.56 1654.76 1034.1 1655.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "870.28 60.63 877.1 126.74 885.59 125.89 878.77 59.75 870.28 60.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "128.78 971.81 129.66 980.31 195.77 973.52 194.91 965 128.78 971.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1723.86 808.03 1724.71 816.49 1790.82 809.74 1789.94 801.24 1723.86 808.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1407.99 266.44 1414.86 271.47 1453.92 217.69 1447.03 212.66 1407.99 266.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "465.7 1563.78 472.63 1568.78 511.65 1515 504.8 1510.02 465.7 1563.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1584.12 1338.86 1579.1 1345.76 1632.88 1384.83 1637.88 1377.93 1584.12 1338.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "281.75 403.54 335.53 442.58 340.53 435.71 286.75 396.63 281.75 403.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1526.9 1409.33 1576.23 1453.95 1581.94 1447.58 1532.64 1403.03 1526.9 1409.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "337.69 333.86 387.01 378.41 392.7 372.13 343.43 327.52 337.69 333.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "396.61 1507.18 402.95 1512.87 447.52 1463.57 441.22 1457.83 396.61 1507.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1472.1 317.95 1478.44 323.63 1523.07 274.36 1516.72 268.63 1472.1 317.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1530.65 376.22 1536.31 382.58 1585.97 338.37 1580.26 332.01 1530.65 376.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.71 1443.1 339.34 1449.48 388.97 1405.25 383.35 1398.88 333.71 1443.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1467.95 1467.23 1512.25 1516.87 1518.53 1511.19 1474.35 1461.55 1467.95 1467.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "401.07 270.3 445.31 319.94 451.67 314.23 407.43 264.65 401.07 270.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1403.44 1518.2 1442.12 1572.32 1449.05 1567.33 1410.37 1513.29 1403.44 1518.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "470.58 214.14 509.23 268.18 516.16 263.26 477.51 209.17 470.58 214.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "278.23 1373.05 283.23 1379.98 337.26 1341.3 332.32 1334.4 278.23 1373.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1582.34 440.2 1587.31 447.12 1641.4 408.45 1636.4 401.49 1582.34 440.2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch01);
export default __webpack_public_path__ + "static/media/Watch-01.1f05a356e84ad156de2058b9643a0fec.svg";
export { ForwardRef as ReactComponent };